
import PropTypes from 'prop-types'
import React from 'react'
import './Block.css'

const Block = props => {
  const {
    color,
    height,
    horizontalCenter,
    maxWidth,
    space,
    spaceBottom,
    spaceChildren,
    spaceLeft,
    spaceRight,
    spaceTop,
    width
  } = props
  let { children } = props
  let hidden = !!props.hidden
  let style = {}
  if (space) {
    style.padding = space + 'px'
  } else {
    if (spaceTop) style.paddingTop = spaceTop + 'px'
    if (spaceBottom) style.paddingBottom = spaceBottom + 'px'
    if (spaceLeft) style.paddingLeft = spaceLeft + 'px'
    if (spaceRight) style.paddingRight = spaceRight + 'px'
  }
  if (horizontalCenter) style.margin = '0 auto'
  if (width) style.width = width + 'px'
  if (color) style.backgroundColor = color
  if (maxWidth) style.maxWidth = maxWidth + 'px'

  // height
  if (typeof height === 'string') {
    style.height = height === 'viewport' ? '100vh' : height
  } else if (typeof height === 'number') {
    style.height = height + 'px'
  }

  if (spaceChildren) {
    children = children.map(function (child, i) {
      let childStyle = {}
      if (i > 0) childStyle.marginTop = spaceChildren + 'px'
      return (
        <div className='BlockChild' style={childStyle} key={`__block_child_${i}`}>{child}</div>
      )
    })
  }

  return <div className='Block' data-center={props.center} style={style} hidden={hidden}>{children}</div>
}

Block.propTypes = {
  children: PropTypes.oneOfType([ PropTypes.object, PropTypes.array ]).isRequired,
  color: PropTypes.string,
  height: PropTypes.number,
  horizontalCenter: PropTypes.string,
  maxWidth: PropTypes.number,
  space: PropTypes.number,
  spaceBottom: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  spaceChildren: PropTypes.number,
  spaceLeft: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  spaceRight: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  spaceTop: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  width: PropTypes.number
}

Block.displayName = 'Block'

export default Block



// WEBPACK FOOTER //
// ./ui/Block.js